import React, { useMemo, useEffect, useState } from "react";
import { TableWrapper } from "../business/style";
import {
  Button,
  Checkbox,
  Col,
  Flex,
  Input,
  message,
  Modal,
  Popover,
  Row,
  Table,
  Tag,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import { Wrapper } from "../data-sources/style";
import { MakeApiCall } from "../../../apis";
import { NumberWithCommas, RenderTable } from "../../../config";
import { CustomColumns } from "./style";
import { useHistory } from "react-router-dom";
import { LoadingModal } from "../../../components/upload-modals";

const DatePickerView = React.lazy(() =>
  import("../data-sources/lib/date-picker-view")
);

const getUniqueFilters = (data, key) => {
  const uniqueValues = [
    ...new Set(data.map((item) => item[key]).filter(Boolean)),
  ];

  return uniqueValues.map((value) => ({
    text: value,
    value,
  }));
};

export default function SearchTermsLine(props) {
  const { searchTermLineItemView, onClose, searchTermFilterList } = props;
  const history = useHistory();
  const lastMonthStartDate = dayjs()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const lastMonthEndDate = dayjs()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");

  const [lineItemsData, setLineItemsData] = useState([]);
  const [lineItemsLoading, setLineItemsLoading] = useState(true);
  const [expandKeywordSearchView, setExpandKeywordSearchView] = useState(
    // null
    []
  );
  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({
    reporting_type: "Monthly", // Weekly
    start_date: lastMonthStartDate,
    end_date: lastMonthEndDate,
    week_no: null,
    month_no: dayjs(lastMonthEndDate, "YYYY-MM-DD").format("M"),
    report_year: dayjs(lastMonthEndDate, "YYYY-MM-DD").format("YYYY"),
  });

  const getAdsSearchTermsLineItemsAction = async (data) => {
    setLineItemsLoading(true);
    setLineItemsData([]);
    try {
      const response = await MakeApiCall(
        `ads/search-terms/campaign-wise?source_type=${
          searchTermFilterList?.source_type || ""
        }&reporting_type=${data?.reporting_type || ""}&week_no=${
          data?.week_no || ""
        }&month_no=${data?.month_no || ""}&report_year=${
          data?.report_year || ""
        }&search_term=${searchTermLineItemView?.data?.search_term || ""}`,
        "get",
        null,
        true
      );

      if (response?.status) {
        setLineItemsData(
          response?.data?.map((d, i) => ({ ...d, cIndex: i + 1 })) || []
        );
        setLineItemsLoading(false);
      } else {
        setLineItemsLoading(false);
        setLineItemsData([]);
        message.warning(response?.message);
      }
    } catch (error) {
      setLineItemsLoading(false);
      setLineItemsData([]);
      message.destroy();
      message.error(error?.message);
    }
  };

  const filterableColumns = ["search_term", "campaign", "match_type"];

  // Generate filter options for each column dynamically
  const columnFilters = useMemo(() => {
    return filterableColumns.reduce((acc, key) => {
      acc[key] = getUniqueFilters(lineItemsData, key);
      return acc;
    }, {});
  }, [lineItemsData]);

  const dynamicOnFilter = (key) => (value, record) => {
    return Array.isArray(value)
      ? value?.some((selected) =>
          typeof value === "string"
            ? record?.[key]?.includes(selected)
            : record?.[key]?.toString()?.includes(value?.toString())
        )
      : record?.[key]?.toString()?.includes(value?.toString());
  };

  const filterDropdownFilter =
    (key) =>
    ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      const handleSelect = (value) => {
        const newSelectedKeys = selectedKeys.includes(value)
          ? selectedKeys.filter((key) => key !== value)
          : [...selectedKeys, value];
        setSelectedKeys(newSelectedKeys);
      };

      const opsList = getUniqueFilters(lineItemsData, key)
        ?.filter((r) => r?.text)
        .filter((option) =>
          typeof option?.text === "string"
            ? option?.text
                ?.toString()
                ?.toLowerCase()
                ?.includes((searchText || "").toLowerCase())
            : option?.text
                ?.toString()
                ?.toLowerCase()
                ?.includes(searchText || "")
        );
      return (
        <div style={{ padding: 8, width: 300 }}>
          <Input
            placeholder={`Search ${key?.split("_")?.join(" ")}...`}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onPressEnter={() => confirm()}
            style={{
              width: "100%",
              marginBottom: 8,
              display: "block",
              padding: 4,
              borderRadius: 4,
              border: "1px solid #d9d9d9",
            }}
          />
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            <div
              style={{
                padding: "6px 12px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox
                onChange={() => {
                  setSelectedKeys(
                    opsList?.length === selectedKeys?.length
                      ? []
                      : opsList?.map((d) => d?.text)
                  );
                }}
                checked={opsList?.length === selectedKeys?.length}
              >
                <b
                  style={{
                    position: "relative",
                    top: "1px",
                  }}
                >
                  {opsList?.length === selectedKeys?.length
                    ? "Deselect All"
                    : "Select All"}
                </b>
              </Checkbox>
            </div>
            {opsList?.map((option) => (
              <div
                key={option.value}
                style={{
                  padding: "6px 12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  checked={selectedKeys.includes(option.value)}
                  onChange={() => handleSelect(option.value)}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "220px",
                      display: "inline-block",
                      position: "relative",
                      top: "3px",
                    }}
                  >
                    {option.text}
                  </span>
                </Checkbox>
              </div>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 8,
            }}
          >
            <Button
              color="primary"
              variant="solid"
              size="small"
              onClick={() => {
                confirm();
                setSearchText("");
              }}
              style={{ padding: "4px 8px", width: "90px" }}
            >
              Apply
            </Button>
          </div>
        </div>
      );
    };

  useEffect(() => {
    getAdsSearchTermsLineItemsAction(filters);
    return () => {};
  }, []);

  const downloadFileLineItems = async () => {
    try {
      message.destroy();
      LoadingModal("Line Items", "Exporting...");
      const response = await MakeApiCall(
        `download-manager/export`,
        "post",
        {
          source_type: "Ads 360",
          record_type: "Search Terms",
          start_date: filters?.start_date,
          end_date: filters?.start_date,
          param_filter: {
            source_type: searchTermFilterList?.source_type,
            month_no: filters?.month_no,
            week_no: filters?.week_no,
            report_year: filters?.report_year,
            reporting_type: filters?.reporting_type,
            search_term: searchTermLineItemView?.data?.search_term || "",
          },
        },
        true
      );
      if (response?.status) {
        Modal.destroyAll();
        message.destroy();
        message.success(response?.message);
        history.push("/download-manager");
      } else {
        Modal.destroyAll();
        message.destroy();
        message.warning(response?.message);
      }
    } catch (error) {
      Modal.destroyAll();
    }
  };

  const getDays = (start_date, end_date) => {
    const date1 = new Date(start_date);
    const date2 = new Date(end_date);

    const timeDifference = date1 - date2; // Difference in milliseconds
    const dayDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to days

    return dayDifference;
  };

  const columns = [
    {
      title: (
        // ""
        <Button
          onClick={() => {
            setExpandKeywordSearchView((prev) => {
              if (prev.length === 0) {
                return lineItemsData?.map((d, i) => i + 1);
              }
              return [];
              // if (prev === row?.cIndex) {
              //   return "";
              // }
              // return row?.cIndex;
            });
          }}
          size="small"
        >
          {expandKeywordSearchView.length > 0 ? "-" : "+"}
        </Button>
      ),
      dataIndex: "keywordIndex",
      key: "keywordIndex",
      className: "highlight-column",

      render: (e, row) => {
        if (!row?.keywordIndex) {
          return (
            <Button
              onClick={() => {
                setExpandKeywordSearchView((prev) => {
                  // if the row is already expanded, collapse it
                  if (prev.includes(row?.cIndex)) {
                    return prev.filter((d) => d !== row?.cIndex);
                  }
                  // otherwise, expand it
                  return [...prev, row?.cIndex];

                  // if (prev === row?.cIndex) {
                  //   return "";
                  // }
                  // return row?.cIndex;
                });
                // setExpandKeywordSearchView((prev) => {
                //   if (prev === row?.cIndex) {
                //     return "";
                //   }
                //   return row?.cIndex;
                // });
              }}
              size="small"
            >
              {expandKeywordSearchView.includes(row?.cIndex) ? "-" : "+"}
            </Button>
          );
        }
        return <div>{""}</div>;
      },
    },
    {
      title: "#",
      dataIndex: "cIndex",
      key: "cIndex",
      className: "highlight-column",
      render: (e) => {
        return <>#{e}</>;
      },
    },
    {
      title: "Search Term",
      width: 250,
      className: "highlight-column",
      filters: columnFilters["search_term"],
      onFilter: dynamicOnFilter("search_term"),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setSearchText("");
        }
      },
      filterDropdown: filterDropdownFilter("search_term"),
      sorter: (a, b) => a?.search_term?.localeCompare(b?.search_term),
      render: (e, row) => {
        return <div>{row?.search_term || ""}</div>;
      },
    },
    {
      title: "Campaign",
      dataIndex: "campaign",
      key: "campaign",
      className: "highlight-column",
      width: 350,
      filters: columnFilters["campaign"],
      onFilter: dynamicOnFilter("campaign"),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setSearchText("");
        }
      },
      filterDropdown: filterDropdownFilter("campaign"),
      sorter: (a, b) => a?.campaign?.localeCompare(b?.campaign),
      render: (e, row) => {
        if (!e) return;
        if (e?.split(",")?.length === 1) {
          return e;
        }
        return (
          <Popover
            content={
              <>
                {e?.split(",")?.map((d) => (
                  <div>{d}</div>
                ))}
              </>
            }
            trigger={["hover"]}
          >
            <div className="one-line-ellipsis">{e || ""}</div>
          </Popover>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "match_type",
      key: "match_type",
      className: "highlight-column",
      filters: columnFilters["match_type"],
      onFilter: dynamicOnFilter("match_type"),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setSearchText("");
        }
      },
      filterDropdown: filterDropdownFilter("match_type"),
      sorter: (a, b) => a?.match_type?.localeCompare(b?.match_type),
      width: 100,
      onFilter: (value, record) => record.match_type.includes(value),
      render: (e) => {
        if (!e) return;
        return (
          <Flex align="baseline">
            <Tooltip title={e} placement="left">
              {(e || "")?.charAt(0)}
            </Tooltip>
          </Flex>
        );
      },
    },
    {
      title: "Traffic Performance",
      width: 250,
      render: (e, row) => {
        return (
          <Row style={{ width: "100%" }} gutter={[5, 5]}>
            <Col span={24}>
              <Flex justify="space-between">
                <span style={{ color: "#676767", marginRight: "5px" }}>
                  Impressions
                </span>
                <span style={{ color: "#009ffb" }}>
                  {NumberWithCommas(row?.impressions || 0)}
                </span>
              </Flex>
            </Col>
            {/* {row?.cIndex === expandKeywordSearchView && ( */}
            {expandKeywordSearchView.includes(row.cIndex) && (
              <>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Clicks
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.clicks || 0)}
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      CTR
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.click_through_rate || 0)}%
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Avg Bid
                    </span>
                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.keyword_bid || 0)}
                    </span>
                  </Flex>
                </Col>
              </>
            )}
          </Row>
        );
      },
    },
    {
      title: "Listing Performance",
      width: 250,
      render: (e, row) => {
        return (
          <Row style={{ width: "100%" }} gutter={[5, 5]}>
            <Col span={24}>
              <Flex justify="space-between">
                <span style={{ color: "#676767", marginRight: "5px" }}>
                  Sales
                </span>

                <span style={{ color: "#009ffb" }}>
                  ${NumberWithCommas(row?.sales || 0)}
                </span>
              </Flex>
            </Col>
            {/* {row?.cIndex === expandKeywordSearchView && ( */}
            {expandKeywordSearchView.includes(row.cIndex) && (
              <>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Purchases
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.purchases || 0)}
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Avg CR
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.conversion_rate || 0)}%
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Avg CPC
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      ${NumberWithCommas(row?.cost_per_click || 0)}
                    </span>
                  </Flex>
                </Col>
              </>
            )}
          </Row>
        );
      },
    },
    {
      title: "Ad Performance",
      width: 250,
      render: (e, row) => {
        return (
          <Row style={{ width: "100%" }} gutter={[5, 5]}>
            <Col span={24}>
              <Flex justify="space-between">
                <span style={{ color: "#676767", marginRight: "5px" }}>
                  Ad Spend
                </span>

                <span style={{ color: "#009ffb" }}>
                  ${NumberWithCommas(row?.spend || 0)}
                </span>
              </Flex>
            </Col>
            {/* {row?.cIndex === expandKeywordSearchView && ( */}
            {expandKeywordSearchView.includes(row.cIndex) && (
              <>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      ACOS
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.acos || 0)}%
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      ROAS
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      {NumberWithCommas(row?.roas || 0)}
                    </span>
                  </Flex>
                </Col>
                <Col span={24}>
                  <Flex justify="space-between">
                    <span style={{ color: "#676767", marginRight: "5px" }}>
                      Avg CPA
                    </span>

                    <span style={{ color: "#009ffb" }}>
                      ${NumberWithCommas(row?.cpa || 0)}
                    </span>
                  </Flex>
                </Col>
              </>
            )}
          </Row>
        );
      },
    },
  ];
  return (
    <TableWrapper
      id="kt_content_container"
      className="container-fluid custom-ui mt-5"
    >
      <div className="card">
        <div
          className="card-header"
          style={{
            background: "white",
            zIndex: 9,
            top: "0px",
            position: "sticky",
          }}
        >
          <div className="card-title" style={{ textTransform: "capitalize" }}>
            <div className="me-3">
              <span
                className="svg-icon svg-icon-muted svg-icon-2hx"
                style={{ cursor: "pointer" }}
                onClick={() => onClose()}
              >
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    opacity="0.3"
                    x={2}
                    y={2}
                    width={20}
                    height={20}
                    rx={5}
                    fill="currentColor"
                  />
                  <path
                    d="M12.0657 12.5657L14.463 14.963C14.7733 15.2733 14.8151 15.7619 14.5621 16.1204C14.2384 16.5789 13.5789 16.6334 13.1844 16.2342L9.69464 12.7029C9.30968 12.3134 9.30968 11.6866 9.69464 11.2971L13.1844 7.76582C13.5789 7.3666 14.2384 7.42107 14.5621 7.87962C14.8151 8.23809 14.7733 8.72669 14.463 9.03696L12.0657 11.4343C11.7533 11.7467 11.7533 12.2533 12.0657 12.5657Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </div>
            {searchTermLineItemView?.data?.search_term || ""} Campaign
          </div>
          <div className="card-toolbar">
            <Wrapper
              style={{ width: "auto", display: "flex", alignItems: "center" }}
            >
              <Tag color="blue-inverse">{filters?.reporting_type}</Tag>
              <DatePickerView
                onChange={(e) => {
                  const reporting_type =
                    getDays(
                      dayjs(e?.end_date)?.format("YYYY-MM-DD"),
                      dayjs(e?.start_date)?.format("YYYY-MM-DD")
                    ) === 0 ||
                    isNaN(
                      getDays(
                        dayjs(e?.end_date)?.format("YYYY-MM-DD"),
                        dayjs(e?.start_date)?.format("YYYY-MM-DD")
                      )
                    )
                      ? null
                      : getDays(
                          dayjs(e?.end_date)?.format("YYYY-MM-DD"),
                          dayjs(e?.start_date)?.format("YYYY-MM-DD")
                        ) > 15
                      ? "Monthly"
                      : "Weekly";

                  const obj = {
                    ...filters,
                    start_date: e?.start_date
                      ? dayjs(e?.start_date)?.format("YYYY-MM-DD")
                      : null,
                    end_date: e?.end_date
                      ? dayjs(e?.end_date)?.format("YYYY-MM-DD")
                      : null,
                    reporting_type: reporting_type,
                    month_no:
                      reporting_type === "Monthly"
                        ? dayjs(e?.start_date)?.format("M")
                        : null,
                    report_year: dayjs(e?.start_date)?.format("YYYY"),
                    week_no:
                      reporting_type === "Weekly"
                        ? dayjs(e?.end_date).week()
                        : null,
                  };
                  setFilters(obj);
                  getAdsSearchTermsLineItemsAction(obj);
                }}
                value={
                  filters?.start_date && filters?.end_date
                    ? [filters?.start_date, filters?.end_date]
                    : null
                }
              />
            </Wrapper>
            <div
              style={{
                background: "#00B660",
                borderRadius: 6,
                padding: "6px 15px",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  color: "#FAFAFB",
                  fontSize: 13,

                  fontWeight: 500,
                  letterSpacing: 0.1,
                  wordWrap: "break-word",
                }}
                onClick={() => downloadFileLineItems()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={20}
                  height={20}
                  viewBox="0 0 24 24"
                  fill="none"
                  className="me-3"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 18.9656L13.3892 18.6653C13.8265 18.328 14.4544 18.409 14.7918 18.8463C15.1291 19.2836 15.0481 19.9115 14.6108 20.2489L12.6277 21.7787C12.5675 21.8274 12.5025 21.8682 12.4342 21.901C12.3808 21.928 12.309 21.9545 12.234 21.9725C12.1375 21.9951 12.0448 22.0033 11.953 21.9989C11.812 21.9924 11.6786 21.9567 11.5588 21.8976C11.4931 21.8654 11.4305 21.8257 11.3723 21.7787L9.38919 20.2489C8.9519 19.9115 8.87088 19.2836 9.20823 18.8463C9.54557 18.409 10.1735 18.328 10.6108 18.6653L11 18.9656V8.45711C11 7.90482 11.4477 7.45711 12 7.45711C12.5523 7.45711 13 7.90482 13 8.45711V18.9656ZM12.5 2C15.0609 2 17.2376 3.76105 17.8369 6.17236C20.2436 6.77356 22 8.95407 22 11.518C22 14.3327 19.8828 16.6868 17.1101 16.9939C16.5612 17.0547 16.0669 16.659 16.0061 16.1101C15.9453 15.5612 16.341 15.0669 16.8899 15.0061C18.6514 14.8109 20 13.3114 20 11.518C20 9.71741 18.6408 8.21401 16.8706 8.02783C16.4009 7.97843 16.0298 7.60718 15.9806 7.13748C15.7947 5.36183 14.2947 4 12.5 4C10.7037 4 9.20292 5.36415 9.01891 7.14171C8.96154 7.69596 8.46222 8.0964 7.90874 8.03205C7.77394 8.01638 7.63757 8.00847 7.5 8.00847C5.56748 8.00847 4 9.57926 4 11.518C4 13.3114 5.34862 14.8109 7.11011 15.0061C7.65903 15.0669 8.05473 15.5612 7.99392 16.1101C7.93311 16.659 7.43882 17.0547 6.88989 16.9939C4.11715 16.6868 2 14.3327 2 11.518C2 8.57497 4.30383 6.17018 7.20435 6.01629C7.85706 3.68561 9.99449 2 12.5 2Z"
                    fill="white"
                  />
                </svg>
                Export
              </div>
            </div>
          </div>
        </div>
        <div className="card-body pt-0 pb-0">
          <CustomColumns>
            <Table
              dataSource={lineItemsData}
              loading={lineItemsLoading}
              rowKey={"key"}
              scroll={{ x: "max-content" }}
              columns={columns?.map((d) => {
                if (lineItemsData?.length === 0) {
                  return {
                    ...d,
                    className: d?.className + "minWidth-table",
                    width: d?.title?.length + 22 * 8,
                    render: (props, row, index) =>
                      RenderTable(props, row, index, d, 10),
                  };
                }
                return {
                  ...d,
                  className: d?.className + "minWidth-table",
                  render: (props, row, index) =>
                    RenderTable(props, row, index, d, 2),
                };
              })}
              rowClassName={(_, index) => {
                return index % 2 === 0 ? "even-row" : "odd-row";
              }}
              bordered
              size="small"
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
              }}
              fixed={true}
              sticky={{
                offsetHeader: "68px",
              }}
            />
          </CustomColumns>
        </div>
      </div>
    </TableWrapper>
  );
}
